import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            w: '100%',
        },
        container: {
            w: '100%',
            maxW: {xl: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
        },
        chevronIcon: {
            w: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            h: {
                base: 'iconsSize.medium',
                md: 'iconsSize.small',
                lg: 'iconsSize.medium',
                xl: 'iconsSize.xlarge',
            },
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            top: {base: remCalc(166), md: remCalc(84), lg: remCalc(113), xl: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            pt: {base: remCalc(16), md: remCalc(40)},
            pb: {base: remCalc(16), md: remCalc(24)},
            w: '100%',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            fontWeight: 'normal',
            pb: {base: remCalc(16), md: remCalc(40)},
        },
        emptyTiles: {
            minH: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
        noswipertiles: {
            gap: {base: remCalc(16), lg: remCalc(24)},
            pb: remCalc(24),
        },
        flexbasis: {
            flexBasis: '25%',
            minH: '100%',
        },
        tile: {
            gap: remCalc(24),
            flexDirection: 'column',
            justifyContent: 'flex-start',
            minH: '100%',
            imagecontainer: {
                textAlign: 'center',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
                minW: {base: remCalc(332), md: 'unset'},
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
            },
            bodycopy: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
            },
            features: {
                listStyleType: 'none',
            },
            feature: {
                py: remCalc(20),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            cta: {
                w: '100%',
                textDecoration: 'none !important',
                alignSelf: 'center',
                whiteSpace: 'unset',
                mt: 'auto',
            },
        },
        ctas: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        ctaPrimary: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            textDecoration: 'none !important',
        },
        ctaSecondary: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            textDecoration: 'none !important',
        },
        ctaInversePrimary: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            textDecoration: 'none !important',
        },
        ctaInverseSecondary: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            textDecoration: 'none !important',
            background: 'button.text.inverse-secondary-default',
            color: 'button.text.primary-default',
            border: remCalc(1),
            _hover: {
                background: 'button.text.primary-default',
                color: 'button.text.inverse-secondary-default',
            },
        },
    },
    variants: {
        recipesCarousel: {
            container: {
                maxW: '100%',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: 'unset',
                minW: 'unset',
            },
            tile: {
                gap: {
                    base: 'xsmall.base',
                    md: 'medium.base',
                },
                minH: 'unset',
                image: {
                    maxWidth: 'unset',
                    minWidth: 'unset',
                },
            },
        },
    },
}
